import { render, staticRenderFns } from "./full_height_image_skeleton_loader.vue?vue&type=template&id=52853960&scoped=true&"
import script from "./full_height_image_skeleton_loader.vue?vue&type=script&lang=js&"
export * from "./full_height_image_skeleton_loader.vue?vue&type=script&lang=js&"
import style0 from "./full_height_image_skeleton_loader.vue?vue&type=style&index=0&id=52853960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52853960",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
